import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const BatchNameColumn = ({ fulfillmentId }) => {
  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const fulfillmentPlanSetId = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'fulfillmentPlanSetId',
    }),
  );
  const fulfillmentPlanSetName =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanSetProperty(state, {
        fulfillmentPlanSetId,
        property: 'fulfillmentPlanSetName',
      }),
    ) ?? '';

  return fulfillmentPlanSetName;
};

BatchNameColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const BatchName = {
  getMessageDescriptor: () => messages.batch,
  id: 'batchName',

  render: (data) => {
    return <BatchNameColumn fulfillmentId={data.id} />;
  },
};
